<div class="root cookie">
  <div class="content-wrap">
    <p>
      We use cookies to enhance your browsing experience and analyze our traffic. You can accept or decline
      non-essential cookies.
    </p>
  </div>
  <div class="actions-wrap">
    <span (click)="decline()" class="main decline">Decline</span>
    <button (click)="accept()" mat-button="filled" disableRipple class="main accept-web accept">Accept</button>
  </div>
</div>
